import { setBridgePaymentMethod } from '../actions/peripheral'
import { bridgePaymentMethods } from '../reducers/peripheral'
import { getPosDeviceType } from '../selectors/peripheral'
import createDataDogLog from '../utils/datadog'
import { POS_DEVICE_TYPES } from '../utils/deviceData'
import { bridge_updateCurrentPaymentFlow, resetCFDrequest } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import {
  setCardAuthStepOne,
  setCardAuthStepTwo,
  setConfirmPaymentDialog,
  setCustomerPayingWithCard,
  setCustomerViewingReceiptDialog,
  setOpenCustomerEnteringTipDialog,
  setOpenCustomerPaymentDialog,
  setTransactionCompleteDialog,
  setTransactionErrorDialog,
} from '../VNDialogs/ActionCreators'
import { MODES } from '../VNMode/Reducer'
import { getDeviceMode } from '../VNMode/Selectors'
import * as ActionTypes from './ActionTypes'
import { CFD_EVENTS, CFD_POS_PAYMENT_FLOWS } from './Enums'
import { CFD_SCREEN } from './Reducer'
import { getCurrentMessageUuid, getCurrentOrder } from './Selectors'

export function setPrintStatus(data) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_SET_PRINT_STATUS,
      data,
    })
  }
}

export function saveCFDAndroidConfig(data) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_SET_ANDROID_CONFIG,
      data,
    })
  }
}

export function setCartTotals(totals) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_SET_CART_TOTALS,
      totals: totals,
    })
  }
}

export function setCFDScreen(screen) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_SET_SCREEN,
      screen: screen,
    })
    dispatch({
      type: ActionTypes.VNCFD_SET_TEMP_SCREEN,
      screen: null,
    })
  }
}

export function setTempCFDScreen(screen) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_SET_TEMP_SCREEN,
      screen: screen,
    })
  }
}

export function setCartTotalsUuid(uuid) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_SET_CART_TOTALS_UUID,
      uuid: uuid,
    })
  }
}

export function setPaymentData(paymentData) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_PAYMENT_DATA,
      data: paymentData,
    })
  }
}

// reset user progress on POS.
export function setUserProgress(paymentProgress) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_USER_PAYMENT_PROGRESS,
      data: paymentProgress,
    })
  }
}

// an update on an order from CFD to POS
export function setOrderUpdate(orderUpdate) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VN_ORDER_UPDATE,
      data: orderUpdate,
    })
  }
}

export function setBalanceToBePaid(balanceToBePaid) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_BALANCE_TO_BE_PAID,
      data: balanceToBePaid,
    })
  }
}

export function setCurrentPaymentFlow(currentFlow, syncAcrossBridge) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_CURRENT_PAYMENT_FLOW,
      currentFlow: currentFlow,
    })

    if (syncAcrossBridge) {
      // we also need to keep the CFD in line, so we need to pass it over the bridge
      bridge_updateCurrentPaymentFlow(currentFlow)
    }
  }
}

export function resetCFD(syncAcrossBridge = true, keepCartData = false, setCFDScreenToIdle = false) {
  return (dispatch, getState) => {
    // don't call if not in CFD
    const curState = getState()
    if (
      (getDeviceMode(curState) !== MODES.POS && getDeviceMode(curState) !== MODES.CFD) ||
      getPosDeviceType(curState) === POS_DEVICE_TYPES.E700
    )
      return

    if (syncAcrossBridge) {
      resetCFDrequest(keepCartData)
    }

    if (setCFDScreenToIdle) {
      dispatch(setCFDScreen(CFD_SCREEN.IDLE))
    }

    dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.UNSET, syncAcrossBridge))
    dispatch(setBalanceToBePaid({}))
    dispatch(updateTransactionLifecycle(CFD_EVENTS.IDLE))
    dispatch(setUserProgress({}))

    dispatch(setCardAuthStepOne({ open: false }))
    dispatch(setCardAuthStepTwo({ open: false }))
    dispatch(setConfirmPaymentDialog(false))
    dispatch(setBridgePaymentMethod(bridgePaymentMethods.executeSaleRequest))
    dispatch(setCustomerViewingReceiptDialog({ open: false }))
    dispatch(setTransactionCompleteDialog(false))
    dispatch(setOpenCustomerPaymentDialog({ open: false }))
    dispatch(setCustomerPayingWithCard({ open: false }))
    dispatch(setOpenCustomerEnteringTipDialog({ open: false }))
    dispatch(setTransactionErrorDialog({ open: false }))

    dispatch({
      type: ActionTypes.VNCFD_EXECUTE_SALES_REQUEST,
      data: {},
    })

    dispatch({
      type: ActionTypes.VNCFD_UPDATE_CART,
      cartItems: [],
    })

    dispatch({
      type: ActionTypes.VNCFD_SET_CART_TOTALS,
      totals: {},
    })

    dispatch({
      type: ActionTypes.VNCFD_TRANSACTION_RESULT,
      data: {},
    })

    dispatch({
      type: ActionTypes.VN_ORDER_UPDATE,
      data: {},
    })
  }
}

export function setCurrentCart(cart) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_CURRENT_CART,
      cart: cart,
    })
  }
}

export function updateTransactionLifecycle(moment) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_UPDATE_TRANSACTION_LIFECYCLE,
      moment: moment,
    })
  }
}

export function setCurrentOrder(order) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_SET_CURRENT_ORDER,
      order: order,
    })
  }
}

export function updateCurrentOrder(order) {
  return (dispatch, getState) => {
    let currentOrder = getCurrentOrder(getState())

    const updatedOrder = {
      ...currentOrder,
      ...order,
    }

    dispatch({
      type: ActionTypes.VNCFD_SET_CURRENT_ORDER,
      order: updatedOrder,
    })
  }
}

export function setCalculatedCurrentCartValues(cart) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_CALCULATED_CURRENT_CART_VALUES,
      cart: cart,
    })
  }
}

export function setAvailableBalance(availableBalance) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNCFD_SET_AVAILABLE_BALANCE,
      availableBalance: availableBalance,
    })
  }
}

export function setCfdWebViewLoaded(isLoaded) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VN_CFD_WEB_VIEW_LOADED,
      isLoaded: isLoaded,
    })
  }
}

/**
 * Track current  message UUID
 */
export function setCurrentMessage(uuid) {
  return (dispatch) => {
    dispatch({ type: ActionTypes.VN_SET_CURRENT_MESSAGE_UUID, uuid })
  }
}

/**
 * Message was confirmed on L1400
 */
export function checkMessageConfirmation() {
  return (dispatch, getState) => {
    const hasPendingMessageId = getCurrentMessageUuid(getState())
    if (hasPendingMessageId) {
      // TODO: [T42290] show error dialog notifying user of issue
      // dispatch(setMessageReceiptErrorDialog())

      createDataDogLog('info', '[CFD Disconnect Error] Unable to receive message receipt from A3700')
    }

    dispatch({ type: ActionTypes.VN_SET_CURRENT_MESSAGE_UUID, uuid: null })
  }
}

/**
 * Response is sent back with incoming UUID, reset message UUID
 */
export function setCurrentMessageAsRead() {
  return (dispatch) => {
    dispatch({ type: ActionTypes.VN_SET_CURRENT_MESSAGE_UUID, uuid: null })
  }
}
